import React, { useState } from 'react';

const IncomeTaxReturnFiling = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with Income Tax Return Filing.',
    website_hp: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with Income Tax Return Filing.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Income Tax Return Filing
            </h1>

            <p className="mt-4 text-xl text-blue-100">
              Professional Income Tax Return Filing services for individuals, businesses, and organizations. We ensure accurate tax calculations, maximum deductions, and timely filing to keep you compliant while optimizing your tax liabilities.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">🧮</span> Maximize Your Tax Savings
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Filing Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of Income Tax Return Filing
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Income Tax Return (ITR) filing is a mandatory annual compliance requirement for individuals and businesses meeting specified income thresholds. It's a declaration of your income, deductions, and tax liabilities to the Income Tax Department.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our comprehensive ITR filing service covers all categories of taxpayers - salaried individuals, business owners, professionals, companies, and NRIs. We ensure accurate filing under the correct ITR form while maximizing your tax savings.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                With expert knowledge of the latest tax laws, deductions, and compliance requirements, we make your tax filing process smooth, accurate, and optimized for maximum benefits.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Maximum Tax Savings:</strong> Expert optimization of deductions under Section 80C, 80D, HRA, and other provisions to minimize your tax liability.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Timely Compliance:</strong> All returns filed before due dates (July 31st for individuals, October 31st for audit cases) to avoid penalties.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Correct ITR Form Selection:</strong> Expert guidance on choosing the right ITR form (ITR-1 to ITR-7) based on your income sources.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Comprehensive Coverage:</strong> Handling all income types - salary, business, capital gains, house property, and other sources.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Tax Notice Support:</strong> Assistance in responding to income tax notices, scrutiny assessments, and rectification requests.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Tax Planning Advisory:</strong> Strategic tax planning for future years to optimize your tax position legally.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Refund Processing:</strong> Expedited processing of tax refunds and tracking until credit to your bank account.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with Income Tax Return Filing." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Comprehensive Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for Income Tax Return Filing
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 grid-flow-row-dense">
            {[
              { number: "01", icon: "📁", title: "Document Collection", desc: "Collect all financial documents - Form 16, bank statements, investment proofs, and income details." },
              { number: "02", icon: "📈", title: "Income Computation", desc: "Calculate total income from all sources - salary, business, capital gains, house property, and other sources." },
              { number: "03", icon: "🛡️", title: "Deduction Optimization", desc: "Identify and maximize eligible deductions under Chapter VI-A (80C, 80D, 80G, etc.) and other sections." },
              { number: "04", icon: "🧮", title: "Tax Liability Calculation", desc: "Compute final tax liability after considering TDS, advance tax, and self-assessment tax payments." },
              { number: "05", icon: "📝", title: "ITR Form Preparation", desc: "Prepare the appropriate ITR form with accurate income, deduction, and tax payment details." },
              { number: "06", icon: "💳", title: "Tax Payment & Verification", desc: "Process any balance tax payments and verify pre-filled data from Form 26AS and AIS." },
              { number: "07", icon: "📤", title: "Online ITR Filing", desc: "File ITR electronically through Income Tax e-filing portal with digital signature or EVC." },
              { number: "08", icon: "🏆", title: "ITR-V Processing", desc: "Submit ITR-V verification and track return processing until intimation under Section 143(1)." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 flex flex-col justify-between p-3 bg-white rounded-xl shadow-md text-center hover:shadow-lg transition-shadow border-t-4 border-blue-500">
                <div className="flex flex-col flex-grow justify-center">
                  <span className="text-xl font-extrabold text-blue-600 block leading-tight">{step.number}</span>
                  <span className="text-2xl mx-auto block leading-none">{step.icon}</span>
                  <h3 className="text-base font-semibold text-gray-900 leading-snug mt-0.5">{step.title}</h3>
                  <p className="text-gray-600 text-sm text-justify mt-1 leading-snug">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Documents Required for ITR Filing
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Essential Documents for Accurate Filing
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "🆔", title: "PAN Card & Aadhaar", desc: "PAN card copy and Aadhaar card for identity verification and linking." },
              { icon: "📄", title: "Form 16/16A", desc: "Form 16 from employer and Form 16A for TDS on other incomes." },
              { icon: "💰", title: "Salary Slips", desc: "Monthly salary slips for the entire financial year for detailed income breakdown." },
              { icon: "🏠", title: "House Property Documents", desc: "Home loan interest certificates, rent receipts, and property tax details." },
              { icon: "📈", title: "Capital Gains Statements", desc: "Brokerage statements for stock trading and capital gains computation." },
              { icon: "🏦", title: "Bank Statements", desc: "Savings and current account statements for interest income and verification." },
              { icon: "🛡️", title: "Investment Proofs", desc: "Proofs for investments under Section 80C, 80D, 80G, and other deductions." },
              { icon: "📊", title: "Business Income Details", desc: "Profit & loss statement, balance sheet for business owners and professionals." },
              { icon: "✅", title: "Previous ITR Copy", desc: "Copy of last year's income tax return for reference and carry-forward losses." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1 text-justify">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>

          {/* 5 equal boxes in a single row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              { icon: "✅", title: "Filed ITR Acknowledgement", desc: "ITR-V acknowledgement and filing confirmation from Income Tax e-filing portal." },
              { icon: "🧮", title: "Tax Computation Report", desc: "Detailed tax computation report showing income, deductions, and final tax liability." },
              { icon: "🛡️", title: "Deduction Optimization Report", desc: "Comprehensive report on deductions claimed and opportunities for future tax savings." },
              { icon: "🔄", title: "ITR-V Verification Support", desc: "Complete support for ITR-V verification through Aadhaar OTP, EVC, or physical submission." },
              { icon: "🎧", title: "Ongoing Tax Support", desc: "Refund tracking until credit, notice response support, tax planning advisory, compliance calendar" }
            ].map((item, index) => (
              <div key={index} className="p-5 bg-white rounded-xl shadow-lg border-l-4 border-green-500 flex flex-col h-full">
                <span className="text-2xl mb-2 block">{item.icon}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-snug">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                  <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                      Common Questions
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      Income Tax Return Filing FAQs
                  </p>
              </div>
              
              <div className="space-y-4 max-w-4xl mx-auto">
                {[
                  { 
                    question: "What is the due date for filing income tax returns?", 
                    answer: "For individuals: July 31st (unless extended). For businesses requiring audit: October 31st. For transfer pricing cases: November 30th." 
                  },
                  { 
                    question: "Who is required to file income tax return?", 
                    answer: "Individuals with gross income exceeding ₹2.5 lakh (₹3 lakh for senior citizens, ₹5 lakh for super seniors), companies, firms, and anyone with specific transactions like foreign travel or high-value investments." 
                  },
                  { 
                    question: "What is the penalty for late filing of ITR?", 
                    answer: "Late filing fee of ₹5,000 (₹1,000 for income below ₹5 lakh) under Section 234F, plus interest under Section 234A for tax payment delay." 
                  },
                  { 
                    question: "Can I revise my income tax return after filing?", 
                    answer: "Yes, you can revise your ITR within the specified time limit (usually by December 31st of the assessment year) if you discover any errors or omissions." 
                  },
                  { 
                    question: "What is Form 26AS and why is it important?", 
                    answer: "Form 26AS is a consolidated tax statement showing TDS, TCS, advance tax, and self-assessment tax details. It's crucial for verifying pre-filled data in ITR." 
                  },
                  { 
                    question: "How long should I keep my income tax records?", 
                    answer: "You should preserve all income tax-related documents for at least 6 years from the end of the relevant assessment year as per income tax laws." 
                  }
                ].map((faq, index) => (
                  <div key={index} className="border rounded-lg p-5 shadow-sm">
                    <h4 className="font-semibold text-lg text-gray-900 mb-2">{faq.question}</h4>
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                ))}
              </div>
          </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-white">
                Ready for Tax Compliance?
            </h2>
            <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
                Let our team of tax experts handle your income tax return filing and maximize your tax savings legally.
            </p>
            <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                <span className="mr-2">📞</span> Consult Our Tax Expert Today
            </a>
        </div>
      </section>
    </main>
  );
};

export default IncomeTaxReturnFiling;